export enum ArabicFont {
  Uthmani,
  Indopak,
  Scheherazade,
  System
}
